import React from "react";
import * as RB from "react-bootstrap";

function AnnocementModal({ show, onHide, title, text, docs }) {
    //console.log(typeof docs)
    return (

        <RB.Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
        //   centered
        >
            <RB.Modal.Header closeButton>
                <RB.Modal.Title>{title}</RB.Modal.Title>
            </RB.Modal.Header>
            <RB.Modal.Body>
                <>
                    <p>{text} </p>
                    {docs && Object.keys(docs).length > 0 && (
                        <div className="row mb-4">
                            <h6>Attachments</h6>
                            <div className="col-12 d-flex flex-wrap">
                                {Object.keys(docs).map((key) => {
                                    const document = docs[key]; // Access the single object directly
                                    const isImage = /\.(jpeg|jpg|png|gif)$/i.test(document.announce_image);
                                    const isPDF = /\.pdf$/i.test(document.announce_image);
                                    const isExcel = /\.(xlsx|xls|csv)$/i.test(document.announce_image);
                                    const isWord = /\.(docx|doc)$/i.test(document.announce_image);

                                    return (
                                        <div
                                            key={key}
                                            className="col-6 col-md-4 col-lg-3 mb-3 file-item"
                                            style={{ minWidth: "150px" }}
                                        >
                                            <a
                                                href={document.attachPath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-center"
                                            >
                                                {isImage ? (
                                                    <i className="material-icons md-96">image</i>
                                                ) : isPDF ? (
                                                    <i className="material-icons md-96">picture_as_pdf</i>
                                                ) : isExcel || isWord ? (
                                                    <i className="material-icons md-96">description</i>
                                                ) : (
                                                    <i className="material-icons md-96">insert_drive_file</i>
                                                )}
                                            </a>
                                            {/* Uncomment if you want to display file name */}
                                            {/* <div className="mt-2 text-sm">{document.file_name}</div> */}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    
                </>
            </RB.Modal.Body>
        </RB.Modal>
    );
}

export default AnnocementModal;
